// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2rPbp","notes":"Notes_notes__3iswx"};